/* ==== IMPORT ==== */

import { addFilter } from '@wordpress/hooks';
import { BlockControls } from '@wordpress/block-editor';
import { ToolbarDropdownMenu } from '@wordpress/components';
const { __ } = wp.i18n;

/* ==== ICONS ==== */

const FlussoIcon = () => {
    return (
        <svg id="EmnFlussoAiIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650 650">
            <g id="Logo_Symbol_Color">
                <g id="Symbol">
                    <path class="cls-3" d="m325,162.5c-89.74,0-162.5,72.75-162.5,162.5v43.59c47.81-27.67,103.28-43.59,162.5-43.59h0v-162.5h0Z" fill="none" />
                    <path class="cls-4" d="m162.5,368.59v-43.59c0-89.75,72.76-162.5,162.5-162.5h0V0h0C145.51,0,0,145.5,0,325v324.97c.01-120.26,65.39-225.18,162.5-281.38Z" fill="#3b87f8" />
                    <path class="cls-4" d="m650,0c0,120.28-65.39,225.21-162.5,281.41v43.59c0,89.75-72.75,162.5-162.5,162.5h0v162.5h0c179.49,0,325-145.5,325-325V0h0Z" fill="#3b87f8" />
                    <path class="cls-2" d="m162.5,368.59v281.41h0c0-89.74,72.75-162.5,162.5-162.5h0v-162.5h0c-59.22,0-114.68,15.92-162.5,43.59Z" fill="#96bffb" />
                    <path class="cls-1" d="m0,649.97v.03h162.5v-281.41C65.39,424.78.01,529.71,0,649.97Z" fill="#3b87f8" />
                    <path class="cls-2" d="m650,0h-162.5c0,89.75-72.75,162.5-162.5,162.5h0v162.5h0c59.22,0,114.68-15.92,162.5-43.59V0h162.5Z" fill="#96bffb" />
                    <path class="cls-1" d="m650,0h-162.5v281.41C584.61,225.21,650,120.28,650,0Z" fill="#3b87f8" />
                </g>
            </g>
        </svg>
    );
}

const FlTranslateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe emn-fl-feather emn-fl-block-icon">
            <circle cx="12" cy="12" r="10" class="emn-fl-stroke-element-hover"></circle>
            <line x1="2" y1="12" x2="22" y2="12" class="emn-fl-stroke-element-hover"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" class="emn-fl-stroke-element-hover"></path>
        </svg>
    );
}

const FlSimplifyIcon = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather feather-square emn-fl-feather emn-fl-block-icon">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" class="emn-fl-stroke-element-hover" fill="none"></rect>
        </svg>
    );
}

const FlComplexifyIcon = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="emn-fl-block-icon">
            <polygon points="12 2 2 7 12 12 22 7 12 2" class="emn-fl-stroke-element-hover"></polygon>
            <polyline points="2 17 12 22 22 17" class="emn-fl-stroke-element-hover"></polyline>
            <polyline points="2 12 12 17 22 12" class="emn-fl-stroke-element-hover"></polyline>
        </svg>
    );
}

const FlSynonymIcon = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="emn-fl-block-icon">
            <polyline points="23 4 23 10 17 10" class="emn-fl-stroke-element-hover"></polyline>
            <polyline points="1 20 1 14 7 14" class="emn-fl-stroke-element-hover"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" class="emn-fl-stroke-element-hover"></path>
        </svg>
    );
}

const FlOppositeIcon = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="emn-fl-block-icon">
            <polyline points="16 3 21 3 21 8" class="emn-fl-stroke-element-hover"></polyline>
            <line x1="4" y1="20" x2="21" y2="3" class="emn-fl-stroke-element-hover"></line>
            <polyline points="21 16 21 21 16 21" class="emn-fl-stroke-element-hover"></polyline>
            <line x1="15" y1="15" x2="21" y2="21" class="emn-fl-stroke-element-hover"></line>
            <line x1="4" y1="4" x2="9" y2="9" class="emn-fl-stroke-element-hover"></line>
        </svg>
    );
}

var selected_text, content_data;

/* ==== BUTTON ==== */

const FlussoAIButton = BlockEdit => { 
    return props => {
        if( props.name !== 'core/paragraph' ){
            return <BlockEdit {...props} />;
        }

        return (
            <>
                <BlockControls>
                    <ToolbarDropdownMenu
                        label={ __( "Flusso AI", "flusso-ai-generated-content" ) }
                        icon={ <FlussoIcon /> }
                        controls={ [
                            {
                                title : __( "Translate", "flusso-ai-generated-content" ),
                                icon : <FlTranslateIcon />,
                                onClick : () => emn_fl_block_handle_content( 'translate', props.clientId, props.attributes.content )
                            },
                            {
                                title : __( "Simplify", "flusso-ai-generated-content" ),
                                icon : <FlSimplifyIcon />,
                                onClick : () => emn_fl_block_handle_content( 'simplify', props.clientId, props.attributes.content )
                            },
                            {
                                title : __( "Complexify", "flusso-ai-generated-content" ),
                                icon : <FlComplexifyIcon />,
                                onClick : () => emn_fl_block_handle_content( 'complexify', props.clientId, props.attributes.content )
                            },
                            {
                                title : __( "Synonym", "flusso-ai-generated-content" ),
                                icon : <FlSynonymIcon />,
                                onClick : () => emn_fl_block_handle_content( 'synonym', props.clientId, props.attributes.content )
                            },
                            {
                                title : __( "Opposite", "flusso-ai-generated-content" ),
                                icon : <FlOppositeIcon />,
                                onClick : () => emn_fl_block_handle_content( 'opposite', props.clientId, props.attributes.content )
                            }
                        ] }
                    />
                </BlockControls>
                <BlockEdit {...props} />
            </>
        );
    };
};

/* ==== FUNCTIONS ==== */

function emn_fl_block_handle_content( action_type, block_id, content ){
    // Translate given content
    content_data = emn_fl_get_block_content( content );
    emn_fl_handle_block_text( action_type, content_data, block_id );
}

/* ==== FUNCTIONS: MISC ==== */

function emn_fl_get_block_content( text_content ){
    // Gets a block content 
    selected_text = window.getSelection().toString();
    content_data = [];
    content_data[ 'is_selection' ] = 0;
    content_data[ 'actual_content' ] = text_content;

    if( selected_text !== '' && selected_text ){
        content_data[ 'is_selection' ] = 1;
        content_data[ 'actual_content' ] = selected_text;
        content_data[ 'selection_start' ] = window.getSelection().getRangeAt( 0 ).startOffset;
        content_data[ 'selection_end' ] = window.getSelection().getRangeAt( 0 ).endOffset;
    }

    return content_data;
}

/* ==== FILTERS ==== */

addFilter( 'editor.BlockEdit', 'flusso-ai-generated-content', FlussoAIButton );